import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a69a9aea&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a69a9aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69a9aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a69a9aea')) {
      api.createRecord('a69a9aea', component.options)
    } else {
      api.reload('a69a9aea', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a69a9aea&scoped=true&", function () {
      api.rerender('a69a9aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4C2EbMGq4iy33/JS/comp/DocBox.vue"
export default component.exports